import { Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { Store } from '@ngxs/store';
import { VButtonV2Component } from 'src/app/core/components/ui-kit/buttons/button-v2/button.component';
import { VEmptyStateComponent } from 'src/app/core/components/ui-kit/empty-state/empty-state.component';
import { SharedModule } from 'src/app/core/shared.module';
import { ListEntitiesToIterable } from 'src/app/store/common/list-entity';
import {
  DeleteNotificationScheduleAction,
  LoadNotificationSchedulesAction,
  UpdateNotificationScheduleAction,
} from 'src/app/store/notifications/notifications.actions';
import { NotificationsState } from 'src/app/store/notifications/notifications.state';
import { NotificationsStateModule } from 'src/app/store/notifications/notifications.state.module';
import { VCardComponent } from '../../../core/components/ui-kit/card/card.component';
import { NotificationSchedulesListComponent } from '../../internal/settings/components/notification-schedules-list/notification-schedules-list.component';
import { VBottomGradientWrapperComponent } from '../components/bottom-gradient/bottom-gradient.component';
import { VLogoHeaderComponent } from '../components/logo-header/logo-header.component';
import { ConfirmService } from 'src/app/services/dialog/confirm.service';

@Component({
  selector: 'app-notification-preferences-page',
  templateUrl: './notification-preferences.component.html',
  imports: [
    SharedModule,
    VCardComponent,
    RouterModule,
    VBottomGradientWrapperComponent,
    VLogoHeaderComponent,
    NotificationSchedulesListComponent,
    NotificationsStateModule,
    VButtonV2Component,
    VEmptyStateComponent,
  ],
})
export class PublicNotificationPreferencesPageComponent implements OnInit {
  private store = inject(Store);
  private route = inject(ActivatedRoute);
  private readonly confirmService = inject(ConfirmService);
  private jwt = this.route.snapshot.queryParamMap.get('jwt') ?? undefined;

  private scheduleEntities = this.store.selectSignal(
    NotificationsState.schedules
  );

  public scheduleEntitiesIterable = computed(() => {
    return ListEntitiesToIterable(this.scheduleEntities()!);
  });

  public isEmpty = computed(() => {
    return this.scheduleEntitiesIterable().entities.length === 0;
  });

  ngOnInit(): void {
    if (this.jwt) {
      this.store.dispatch(new LoadNotificationSchedulesAction(this.jwt));
    }
  }

  deleteSchedule(scheduleId: string): void {
    this.confirmService
      .confirm({
        title: 'resources.notificationSchedule.actions.delete.long',
        description:
          'resources.notificationSchedule.actions.delete.confirmation',
        confirmLabel: 'resources.notificationSchedule.actions.delete.short',
        tone: 'danger',
        icon: 'trash',
      })
      .subscribe(confirmed => {
        if (!confirmed) {
          return;
        }
        this.store.dispatch(
          new DeleteNotificationScheduleAction(scheduleId, this.jwt)
        );
      });
  }

  disableSchedule(scheduleId: string) {
    this.store.dispatch(
      new UpdateNotificationScheduleAction(
        scheduleId,
        { enabled: false },
        this.jwt
      )
    );
  }

  enableSchedule(scheduleId: string) {
    this.store.dispatch(
      new UpdateNotificationScheduleAction(
        scheduleId,
        { enabled: true },
        this.jwt
      )
    );
  }
}
